<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('listeProjets.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="is-pulled-right buttons boutonAction">
              <a class="button is-addOrEdit"
                 @click="popUpNewProjet = true">
                {{ $t('listeProjets.actions.add')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px level">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="manageActions"
            :options='[]'
            :placeholder='$t("general.placeHolder.groupedAction")'
            :titleButton="'general.button.apply'"
            :elementsSelectionnes="false"
          ></selecteur-action>
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('general.button.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
        </div>
        <div class="column is-narrow">
          <button class="button" @click="setShowFiltre">
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
          </button>
          <span
            class="info-circle-right is-pulled-right is-cursor-pointer"
            @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
        </div>
      </div>
      <div class="level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="constantes.PROJETS.exporter"
            in-progress/>
        </div>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" ref="tableProjets"
                    @loaded="finLoading" @loading="debutLoading" class="mgt-20px">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableProjets.setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="libelle" slot-scope="props">
        <router-link :to="{ name: 'm.logistique.projets', params: { id: props.row.id }}"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(constantes.PROJETS.lecture)}">
          {{ props.row.libelle }}
        </router-link>
      </div>
      <div slot="nbrDossier" slot-scope="props" >
        {{ props.row.dossiers.length }}
      </div>
      <div slot="nbrOt" slot-scope="props">
        {{ getNombreOt(props.row) }}
      </div>
      <div slot="progression" slot-scope="props">
        {{ getNumberTaskDone(props.row) + ' / ' + getNumberTask(props.row) }}
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ props.row.archive ? $t('general.oui') : $t('general.non') }}</div>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link
          :to="{ name: 'm.logistique.projets', params: { id: props.row.id} }">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PROJETS.maj) }"></b-icon>
        </router-link>
      </div>
      <div slot="archive" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(constantes.PROJETS.supprimer) ?
          openPopUpArchivage(props.row) : showPopUp()">
          <b-icon :icon="!props.row.archive ? 'archive' : 'archive-arrow-up'"
                  type="is-default"
                  :class="{
              'text-access-no-permission' : !checkPermissions(constantes.PROJETS.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(constantes.PROJETS.supprimer)
        ? prepareDeleteProjet(props.row.id) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(constantes.PROJETS.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <b-modal v-model="popUpNewProjet" has-modal-card class="modal">
      <pop-up-ajout-projet @refresh="recherche">
      </pop-up-ajout-projet>
    </b-modal>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-projet
        ref="filtreProjet"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="popUpPreventionDelete" has-modal-card class="modal">
      <pop-up-prevention @yes="deleteProjet(projetIdToDelete)"
                         @no="popUpPreventionDelete = false"
                         :messHeader="$t('listeProjets.deleteProjet')"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpArchivage" has-modal-card class="modal">
      <pop-up-prevention @yes="archiverProjet"
                         @no="popUpArchivage = false"
                         :messHeader="$t(projetToArchive.libelle)"
                         :cancel="$t('general.non')"
                         :validate="$t('general.oui')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import breadcrumb from '@/components/general/breadcrumb';
import { createNamespacedHelpers } from 'vuex';
import { PROJETS } from '@/configuration/logistique/permissionsLogistiqueConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import genererCritereRecherche from '@/services/logistique/projets/genererCritereRechercheProjets';
import inProgress from '@/services/general/inProgress';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import selecteurAction from '@/components/general/selecteurAction';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import popUpAjoutProjet from '@/components/logistique/projets/p_ajoutProjet';
import subscribeMutation from '@/services/store/subscribeMutation';
import messageErreur from '@/services/general/messageErreur';
import filtreProjet from '@/components/logistique/projets/filtreProjet';
import { deleteProjet, archiver } from '@/api/logistique/projets';
import popUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { SET_CRITERE } from '@/store/modules/logistique/projets-mutation-type';
import messageSucces from '@/services/general/messageSucces';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Projets = createNamespacedHelpers('projets');

export default {
  data() {
    return {
      unsubscribeValue: null,
      showFiltre: false,
      projetIdToDelete: null,
      constantes: {
        PROJETS,
      },
      popUpNewProjet: false,
      popUpPreventionDelete: false,
      popUpArchivage: false,
      projetToArchive: {
        archive: false,
        libelle: null,
        libelleSuccess: null,
        ids: [],
      },
    };
  },
  components: {
    breadcrumb,
    popUpPrevention,
    TableItemsInView,
    selecteurAction,
    popUpAjoutProjet,
    filtreProjet,
    exportExcelButton,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Projets.mapActions({
      loadProjet: 'loadProjet',
    }),
    ...Projets.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    openPopUpArchivageMulti(archive) {
      const ids = this.getAllProjetSelected();
      this.projetToArchive = {
        archive: archive,
        libelle: archive ? 'listeProjets.archivageDesarchiver.desarchivageMulti' : 'listeProjets.archivageDesarchiver.archivageMulti',
        libelleSuccess: archive ? 'listeProjets.messages.success.desarchivageMulti' : 'listeProjets.messages.success.archivageMulti',
        ids: ids,
      };
      this.popUpArchivage = true;
    },
    openPopUpArchivage(projet) {
      this.projetToArchive = {
        archive: !projet.archive,
        libelle: projet.archive ? 'listeProjets.archivageDesarchiver.desarchivage' : 'listeProjets.archivageDesarchiver.archivage',
        libelleSuccess: projet.archive ? 'listeProjets.messages.success.desarchivage' : 'listeProjets.messages.success.archivage',
        ids: [projet.id],
      };
      this.popUpArchivage = true;
    },
    async archiverProjet() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpArchivage = false;
        await archiver(this.projetToArchive.ids, this.projetToArchive.archive);
        messageSucces(this.$i18n.t(this.projetToArchive.libelleSuccess));
        this.projetToArchive = {
          archive: false,
          libelle: null,
          libelleSuccess: null,
          ids: [],
        };
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    prepareDeleteProjet(projetId) {
      this.projetIdToDelete = projetId;
      this.popUpPreventionDelete = true;
    },
    async deleteProjet(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteProjet(id);
        this.popUpPreventionDelete = false;
        loadingComponent.close();
        messageSucces(this.$i18n.t('listeProjets.messages.success.deleteProjet'));
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getNombreOt(projet) {
      let ot = 0;
      projet.dossiers.forEach((dossier) => {
        if (dossier.ots) ot += dossier.ots.length;
      });
      return ot;
    },
    getNumberTaskDone(projet) {
      let task = 0;
      projet.dossiers.forEach((dossier) => {
        dossier.ots.forEach((ot) => {
          task += ot.taches.filter((tache) => { return tache.realise; }).length;
        });
      });
      return task;
    },
    getNumberTask(projet) {
      let task = 0;
      projet.dossiers.forEach((dossier) => {
        dossier.ots.forEach((ot) => {
          task += ot.taches.length;
        });
      });
      return task;
    },
    getPercent(projet) {
      if (projet.dossiers.length === 0 || this.getNumberTask(projet) === 0) return 0;
      return (this.getNumberTaskDone(projet) * 100) / this.getNumberTask(projet);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableProjets.refresh();
    },
    goFirstPage() {
      this.setCritereRecherche(genererCritereRecherche());
      this.$refs.tableProjets.setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreProjet.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreProjet.initializeFiltre();
      this.$refs.filtreProjet.viderCritere();
      this.$refs.filtreProjet.appliquerCritere();
      this.showFiltre = false;
    },
    manageActions() {
      this.inProgress();
    },
    getAllProjetSelected() {
      return this.projets.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allProjetSelected;
      this.projets.forEach(item => { item.selected = select; });
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Projets.mapGetters({
      projets: 'items',
      total: 'totalCount',
      criteresRecherche: 'criteresRecherche',
    }),
    allProjetSelected() {
      return this.getAllProjetSelected().length === this.projets.length
        && this.projets.length > 0;
    },
    nombreCritere() {
      const banCritere = ['auto', 'archive'];
      let filtre = calculNombreCritere(this.criteresRecherche, banCritere);
      filtre += this.criteresRecherche.archive !== null ? 1 : 0;
      return filtre <= 9 ? filtre : '+9';
    },
    columns() {
      return ['selected', 'libelle', 'nbrDossier', 'nbrOt', 'progression', 'actif', 'edit', 'archive', 'delete'];
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProjets.breadcrumb.listeProjets'), route: '', isActive: true },
      ];
    },
    iconSelectTotal() {
      if (this.allProjetSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$i18n.t('listeProjets.tabs.libelle'),
          nbrDossier: this.$i18n.t('listeProjets.tabs.nbrDossier'),
          nbrOt: this.$i18n.t('listeProjets.tabs.nbrOt'),
          progression: this.$i18n.t('listeProjets.tabs.progression'),
          actif: this.$i18n.t('listeProjets.tabs.archiver'),
          exporter: '',
          edit: '',
          archive: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          if (!data.query.agencesIds || data.query.agencesIds.length === 0) {
            data.query.agencesIds = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadProjet(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.projets,
            count: this.total,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          archive: 'colonneSelected',
        },
        sortable: ['libelle'],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$i18n.t('pageLogistique.projet.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
